module.exports = __webpack_public_path__ + "img/microsoft_access_permissions_consent_screen.50a95301.png";